import React, { useState }from 'react';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { Popconfirm, Button, Icon, message } from 'antd';
import { deleteEvent, getCandidate } from './../API';
import { s3 } from './../utils';
const { uniqBy } = require('lodash');

function CandidatePopConfirm(props) {
  const session = useMappedState(state => state.session);
  const candidateContactList = useMappedState(state => state.candidateContactList);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const reloadCandidate = async (candidateID) => {
    const response = await getCandidate(session.authToken, candidateID);

    if (response.data.responseCode === 0) {
      dispatch({type: "INIT_CANDIDATE", payload: response.data.candidate});

      //re-construct all available contacts from events
      const allContacts = uniqBy(response.data.candidate.events.filter(i => i.contact).map(x => x.contact), 'id');
      dispatch({
        type: "SET_CANDIDATE_CONTACTS_LIST",
        payload: allContacts.map(i => {
          return {
            ...i,
            ...{avatar: `${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.id}.jpeg`}
          }
        })
      });

      if (candidateContactList.contact !== 'all'
          && !allContacts.map(i => i.id).includes(candidateContactList.contact)) {
        dispatch({type: "SET_CANDIDATE_CONTACTS_LIST_SELECTION", payload: 'all'});
      }
    }
  }

  const handelOnClickRemoveEvent = async (i, c) => {
    setLoading(true);
    const result = await deleteEvent(session.authToken, {id: i.id});

    if (result.data.responseCode === 0) {
      reloadCandidate(c);
      setLoading(false);
      message.success(result.data.message);
    }
    else {
      setLoading(false);
      dispatch({type: "OPEN_MSG_MODAL", payload: result.data.message});
    }
  }

  return (
    <Popconfirm
      placement="left"
      title="Are you sure to delete this event?"
      onConfirm={() => handelOnClickRemoveEvent(props.event, props.candidateID)}
      okText="Yes"
      cancelText="No"
    >
      <Button size="small">
        {
          loading ?
          <Icon type="loading" />
          :
          <Icon type="delete" />
        }
      </Button>
    </Popconfirm>
  );
}

export default CandidatePopConfirm;
